import addClickHandler from '../events/addClickHandler';
import addStartupScript from '../events/addStartupScript';
import forEachSelector from '../elements/forEachSelector';
import logError from '../util/logError';
import MicroModal from 'micromodal';

const MODAL_TRIGGER_SELECTOR = '[data-trigger=modal-dialog]';

/**
 * Instantiate the micromodal and show it
 *
 * @param {String} modalId
 */
const showModal = (modalId) => {
  MicroModal.show(modalId, {
    openClass: 'js-modal-dialog--open'
  });
};

/**
 * On modal trigger click, show the modal matching the 'data-modal-dialog-id' attribute on
 * the trigger. If no attribute exists and/or there is no associated modal, send a NR error.
 *
 * @param {event} event Modal trigger click event
 */
const handleTriggerClick = (event) => {
  const modalId = event.target?.dataset?.modalDialogId;
  const modalEl = modalId && document.querySelector(`.modal-dialog#${modalId}`);

  // show modal if modalId and modalEl are present; otherwise send NR error
  if (modalId && modalEl) {
    showModal(modalId);
  } else if (!modalId) {
    logError('ModalDialog error: Trigger missing modal ID', {
      customAttributes: { modalTrigger: event.target },
    });
    return;
  } else if (!modalEl) {
    logError('ModalDialog error: Triggered modal not found', {
      customAttributes: { modalId, modalTrigger: event.target },
    });
    return;
  }
};

export function setup() {
  forEachSelector(MODAL_TRIGGER_SELECTOR, (el) => {
    addClickHandler(el, handleTriggerClick);
  });
}

addStartupScript(setup);
